export class AuthRedirectError extends Error {
  constructor() {
    super('AUTH_REDIRECT')
    this.name = 'AuthRedirectError'
  }
}

export function isAuthRedirectError(error) {
  return error?.name === 'AuthRedirectError'
}

export function requireAuthResponse(response) {
  if (!response) throw new AuthRedirectError()
  return response
}
